// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"96a66fd6","453":"a12f2861"}[chunkId] + ".chunk.js";
};